import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UtilService } from '../../services/util.service';

/** Homepage "Still looking? Just ask." search strip (Figma Wireframe_v2 ASK). Searches the
 *  same way as the homepage/header search: /search?q=… plus the util search trigger. */
@Component({
  selector: 'app-home-ask',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './home-ask.component.html',
  styleUrl: './home-ask.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeAskComponent {
  private router = inject(Router);
  private util = inject(UtilService);

  readonly suggestions = ['orange banner vinyl 54 in', 'ACM 3 mm white', 'navy awning fabric', 'eco-solvent cyan'];

  search(value: string): void {
    const q = value.trim();
    this.util.triggerSearch(q);
    this.router.navigate(['/search'], { queryParams: { q } });
  }
}
